export default __webpack_public_path__ + "static/media/chainlink.151a15d7.svg";